import { FC, memo } from 'react';
import { IconSize, IconType, IconWrap } from '@tools/ui/dime';
import { TransactionDirection } from '../../../consts/reco.const';

type TProps = {
  direction?: string;
};

const FundsDirection: FC<React.PropsWithChildren<TProps>> = ({ direction }) => {
  const fundsDirection =
    direction?.toLowerCase() === TransactionDirection.Credit
      ? IconType.CreditDirection
      : IconType.DebitDirection;

  return <IconWrap size={IconSize.Small} type={fundsDirection} />;
};
export default memo(FundsDirection);
